"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderGivenPricePreview = void 0;
var aov_helper_const_1 = require("@src/const/aov-helper.const");
var input_output_helper_const_1 = require("@src/const/input-output-helper.const");
var input_mapping_const_1 = require("@src/const/input.mapping.const");
var element_generator_1 = require("@src/element-generator");
var object_service_1 = require("@src/services/object-service");
var settings_service_1 = require("@src/services/settings.service");
var translation_1 = __importDefault(require("@src/services/translation"));
/**
 * Simply loads a given pricing option
 */
var RenderGivenPricePreview = /** @class */ (function () {
    function RenderGivenPricePreview() {
        var _this = this;
        this.generator = object_service_1.ObjectService.getInstance(element_generator_1.ElementGenerator);
        this.config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
        this.dontRenderPricePreview = false; // used it price preview has children and renders only data handlers
        this.timeMapping = {
            'Alle 1 Years': translation_1.default.t('yearly'),
            '1 YEARS': translation_1.default.t('yearly'),
            '1 YEAR': translation_1.default.t('yearly'),
            'Alle 12 Monate': translation_1.default.t('yearly'),
            '12 MONTHS': translation_1.default.t('yearly'),
            '12 MONTH': translation_1.default.t('yearly'),
            '1 MONTHS': translation_1.default.t('monthly'),
            '1 MONTH': translation_1.default.t('monthly'),
            'Alle 1 Monate': translation_1.default.t('monthly'),
            'Alle 6 Monate': translation_1.default.t('semi-annually'),
            '6 MONTHS': translation_1.default.t('semi-annually'),
            '6 MONTH': translation_1.default.t('semi-annually'),
            '1 WEEKS': translation_1.default.t('weekly'),
            '1 WEEK': translation_1.default.t('weekly'),
            'Alle 1 Wochen': translation_1.default.t('weekly'),
            '1 DAYS': translation_1.default.t('daily'),
            '1 DAY': translation_1.default.t('daily'),
            'Alle 1 Tage': translation_1.default.t('daily'),
        };
        this.renderPrice = function (renderPricing) {
            _this._studioName = renderPricing.studioName;
            _this.selectedTerm = renderPricing.term;
            _this.selectedOffer = renderPricing.offering;
            _this.paidModules = renderPricing.paidModules;
            _this.freeModules = renderPricing.freeModules;
            _this.preview = renderPricing.preview;
            _this.contractStartDate = renderPricing.startDate;
            _this.contractStartDateOfUse = renderPricing.preuseDate;
            // it will have children after, need to keep track that it was fully generated
            _this.$container.get(0).setAttribute('generate-full-pricing-preview', 'true');
            _this.generatePricingOverview();
        };
        this.clearVoucherPreview = function () {
            if (!_this.preview)
                return;
            _this.preview = __assign(__assign({}, _this.preview), { discountValue: undefined, discountType: undefined, discountedBasePrice: undefined, discountedPreUseCharge: undefined, creditValue: undefined, effectivePeriodTimeBasedTerm: undefined, effectivePeriodTimeBasedTermUnit: undefined, flatFeePreviews: undefined, selectedOptionalModulesPreviews: undefined });
        };
        this.pricingDetails = [];
        this.appendPricingDetails = function (pricingDetails) {
            var _a;
            _this.generatePricingOverview();
            if (pricingDetails.attr('data-voucher-success-message') === 'true') {
                _this.pricingDetails = _this.pricingDetails.filter(function (detail) { return detail.attr('data-voucher-success-message') !== 'true'; });
            }
            _this.pricingDetails.push(pricingDetails);
            console.log('Re-rendering price details', _this.pricingDetails);
            // workaround to fix adding the same message multiple times
            // voucher code validation keeps adding the same "voucher successfully applied" messages
            _this.pricingDetails = _this.pricingDetails.reduce(function (acc, elem) {
                var message = elem.html();
                if (!acc.some(function (e) { return e.html() === message; })) {
                    acc.push(elem);
                }
                return acc;
            }, []);
            (_a = _this.$container).append.apply(_a, _this.pricingDetails);
        };
        // dont remove all container content if the data handler mode is used
        this.removePricingDetails = function () {
            if (!_this.dontRenderPricePreview) {
                _this.pricingDetails = [];
                _this.generatePricingOverview();
            }
        };
    }
    RenderGivenPricePreview.prototype.loadModule = function () {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); });
    };
    RenderGivenPricePreview.prototype.generatePricingOverview = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21;
        var elements = [];
        this.$container.empty();
        (0, input_output_helper_const_1._SaveFieldInLocalstorage)(input_mapping_const_1._AllMappings.rateBundleAOV, JSON.stringify((0, aov_helper_const_1._CalculateAOV_V2)(this.selectedTerm, this.paidModules, this.preview)));
        if ((_a = this._studioName) === null || _a === void 0 ? void 0 : _a.length) {
            elements.push(this.generator.getRow({
                html: translation_1.default.t('Studio') + ' ' + this._studioName,
                css: {
                    fontSize: '12px',
                    fontWeight: 'bold',
                    color: 'rgba(26, 41, 54, .75)',
                    margin: '10px 0 4px 0',
                },
            }));
        }
        //FIRST HALF
        //FREE BONUS
        if ((_c = (_b = this.selectedTerm) === null || _b === void 0 ? void 0 : _b.rateBonusPeriods) === null || _c === void 0 ? void 0 : _c.length) {
            for (var _i = 0, _22 = this.selectedTerm.rateBonusPeriods; _i < _22.length; _i++) {
                var bonus = _22[_i];
                this.bonusTimeElements(elements, bonus);
            }
        }
        // Flat fees
        var feeSumPrice = 0;
        var sorted = [];
        var _loop_1 = function (fee) {
            var interval = (fee === null || fee === void 0 ? void 0 : fee.paymentFrequency) ? this_1.timeMapping[fee.paymentFrequency] || fee.paymentFrequency : '';
            var price_1 = (_g = (_f = (_e = (_d = this_1.preview) === null || _d === void 0 ? void 0 : _d.flatFeePreviews) === null || _e === void 0 ? void 0 : _e.find(function (p) { return p.name === fee.name; })) === null || _f === void 0 ? void 0 : _f.discountedPrice) !== null && _g !== void 0 ? _g : fee.price;
            var discountLine = price_1 !== fee.price ? "<del>".concat(translation_1.default.transformCurrency(fee.price), "</del>  ") : '';
            var row = this_1.generator.twoColSetup(fee.name, interval + ' ' + discountLine + translation_1.default.transformCurrency(price_1) + '€', {
                fontSize: '12px',
                fontWeight: this_1.selectedTerm.flatFees.length === 1 ? 'bold' : 'normal',
            });
            if (fee.paymentFrequencyType === 'RECURRING') {
                elements.push(row);
            }
            else {
                feeSumPrice += price_1;
                sorted.push(row);
            }
        };
        var this_1 = this;
        for (var _23 = 0, _24 = this.selectedTerm.flatFees; _23 < _24.length; _23++) {
            var fee = _24[_23];
            _loop_1(fee);
        }
        if (sorted.length > 0) {
            elements.push.apply(elements, sorted);
            if (((_j = (_h = this.selectedTerm) === null || _h === void 0 ? void 0 : _h.flatFees) === null || _j === void 0 ? void 0 : _j.length) > 1) {
                elements.push(this.generator.twoColSetup(translation_1.default.t('onceFlatRates'), '' + translation_1.default.transformCurrency(this.roundDecimals(feeSumPrice, 2)) + '€', {
                    fontWeight: 'bold',
                    color: 'rgba(26, 41, 54, .75)',
                    marginTop: '4px',
                    fontSize: '12px',
                }));
            }
            elements.push(this.generator.getDividerLine());
        }
        //Laufzeiten
        var contractDuration = this.selectedTerm.termValue;
        //SECOND HALF
        this.bonusPeriodInSummary(elements);
        var customerAge = +localStorage.getItem('age');
        var price = this.selectedTerm.price;
        //Age based adjustment stuff
        if (customerAge > 0 &&
            ((_l = (_k = this.selectedTerm) === null || _k === void 0 ? void 0 : _k.ageBasedAdjustmentDtos) === null || _l === void 0 ? void 0 : _l.length) &&
            this.selectedTerm.ageBasedAdjustmentDtos.some(function (a) { var _a, _b; return customerAge > ((_a = a === null || a === void 0 ? void 0 : a.ageRangeDto) === null || _a === void 0 ? void 0 : _a.startAge) && customerAge < ((_b = a === null || a === void 0 ? void 0 : a.ageRangeDto) === null || _b === void 0 ? void 0 : _b.endAge); })) {
            price = this.selectedTerm.ageBasedAdjustmentDtos.find(function (a) { var _a, _b; return customerAge > ((_a = a === null || a === void 0 ? void 0 : a.ageRangeDto) === null || _a === void 0 ? void 0 : _a.startAge) && customerAge < ((_b = a === null || a === void 0 ? void 0 : a.ageRangeDto) === null || _b === void 0 ? void 0 : _b.endAge); }).value;
        }
        var discountedPrice = price;
        if (((_m = this.preview) === null || _m === void 0 ? void 0 : _m.discountType) === 'PERCENTAGE') {
            discountedPrice = price * ((100 - ((_p = (_o = this.preview) === null || _o === void 0 ? void 0 : _o.discountValue) !== null && _p !== void 0 ? _p : 0)) / 100);
        }
        var discountedText = discountedPrice !== price ? "<del>".concat(translation_1.default.transformCurrency(price), "</del>") : '';
        var paymentInterval = this.selectedTerm.paymentFrequencyValue + ' ' + this.selectedTerm.paymentFrequencyUnit + 'S';
        var paymentText = this.timeMapping[paymentInterval] ||
            translation_1.default.t('Every') +
                ' ' +
                this.selectedTerm.paymentFrequencyValue +
                ' ' +
                translation_1.default.t(this.selectedTerm.paymentFrequencyUnit + 'S');
        // if the contract has only one payment, show now frequency (e.g just X€)
        var hasOnlyOnePayment = ((_q = this.selectedTerm) === null || _q === void 0 ? void 0 : _q.extensionType) === 'NONE' &&
            ((_r = this.selectedTerm) === null || _r === void 0 ? void 0 : _r.paymentFrequencyUnit) === ((_s = this.selectedTerm) === null || _s === void 0 ? void 0 : _s.termUnit) &&
            ((_t = this.selectedTerm) === null || _t === void 0 ? void 0 : _t.paymentFrequencyValue) === ((_u = this.selectedTerm) === null || _u === void 0 ? void 0 : _u.termValue);
        elements.push(this.generator.twoColSetup(this.selectedOffer.name, (!hasOnlyOnePayment ? paymentText : '') + '    ' + discountedText + '   ' + translation_1.default.transformCurrency(discountedPrice) + '€', {
            fontSize: '12px',
            fontWeight: 'bold',
            color: 'rgba(26, 41, 54, .75)',
        }));
        if ((_v = this.preview) === null || _v === void 0 ? void 0 : _v.effectivePeriodTimeBasedTerm) {
            var newPriceText = translation_1.default.t('creditMembershipAdjustmentRule', {
                newPrice: price.toFixed(2),
                value: ((_x = (_w = this.preview) === null || _w === void 0 ? void 0 : _w.effectivePeriodTimeBasedTerm) !== null && _x !== void 0 ? _x : 0) + 1,
                unit: translation_1.default.t((_y = this.preview) === null || _y === void 0 ? void 0 : _y.effectivePeriodTimeBasedTermUnit),
                article: translation_1.default.t(((_z = this.preview) === null || _z === void 0 ? void 0 : _z.effectivePeriodTimeBasedTermUnit) === 'WEEK' ? 'week_article_dative' : 'month_article_dative'),
            });
            elements.push(this.generator.twoColSetup('', newPriceText, {
                fontSize: '12px',
                fontWeight: 'bold',
                color: 'rgba(26, 41, 54, .75)',
            }));
        }
        var contractStartDate = (_0 = this.contractStartDate) !== null && _0 !== void 0 ? _0 : this.selectedTerm.defaultContractStartDate;
        if (contractStartDate) {
            elements.push(this.generator.twoColSetup(translation_1.default.t('Contract start'), this.formatDate(contractStartDate), {
                fontSize: '12px',
                fontWeight: 'bold',
                color: 'rgba(26, 41, 54, .75)',
            }));
        }
        var contractStartDateOfUse = (_1 = this.contractStartDateOfUse) !== null && _1 !== void 0 ? _1 : this.selectedTerm.contractStartDateOfUse;
        if (contractStartDateOfUse && contractStartDateOfUse !== contractStartDate) {
            elements.push(this.generator.twoColSetup(translation_1.default.t('Contract start of use'), this.formatDate(contractStartDateOfUse), {
                fontSize: '12px',
                fontWeight: 'bold',
                color: 'rgba(26, 41, 54, .75)',
            }));
        }
        elements.push.apply(elements, this.addExtraModules('free', this.freeModules));
        elements.push.apply(elements, this.addExtraModules('paid', this.paidModules));
        //SubsequentRateDto
        if ((_2 = this.selectedTerm) === null || _2 === void 0 ? void 0 : _2.subsequentRateDto) {
            var term = this.selectedTerm.subsequentRateDto.terms[0];
            price = term.price;
            //TODO: WHAT IS THIS DOING???
            // this.timeMapping[paymentInterval] ||
            //   i18n.t('Every') +
            //   ' ' +
            //   term.paymentFrequencyValue +
            //   ' ' +
            //   i18n.t(term.paymentFrequencyUnit + 'S');
        }
        //Terms & conditions
        elements.push(this.generator.getDividerLine());
        if (((_3 = this.selectedTerm) === null || _3 === void 0 ? void 0 : _3.extensionType) === 'NONE') {
            elements.push(this.generator.getRow({
                html: "Der Vertrag endet nach der Erstlaufzeit.",
                css: { fontSize: '12px' },
            }));
        }
        else {
            var termCancellation = void 0;
            if (((_4 = this.selectedTerm) === null || _4 === void 0 ? void 0 : _4.extensionType) === 'SUBSEQUENT_RATE_DETAIL' && ((_7 = (_6 = (_5 = this.selectedTerm) === null || _5 === void 0 ? void 0 : _5.subsequentRateDto) === null || _6 === void 0 ? void 0 : _6.terms) === null || _7 === void 0 ? void 0 : _7.length)) {
                termCancellation = {
                    value: +this.selectedTerm.subsequentRateDto.terms[0].termValue,
                    unit: this.selectedTerm.subsequentRateDto.terms[0].termUnit,
                };
            }
            else if (((_8 = this.selectedTerm) === null || _8 === void 0 ? void 0 : _8.extensionType) === 'TERM_EXTENSION') {
                termCancellation = {
                    value: +this.selectedTerm.extensionFixedTerm,
                    unit: this.selectedTerm.extensionFixedTermUnit,
                };
            }
            var cancellationPeriodText = termCancellation && (termCancellation === null || termCancellation === void 0 ? void 0 : termCancellation.value) > 0 && !((termCancellation === null || termCancellation === void 0 ? void 0 : termCancellation.value) === 1 && (termCancellation === null || termCancellation === void 0 ? void 0 : termCancellation.unit) === 'MONTH')
                ? translation_1.default.t(' um eine ') + termCancellation.value + ' ' + this.i18nInterval(termCancellation.unit, termCancellation.value)
                : translation_1.default.t(' als monatlich ');
            if ((_10 = (_9 = this.config.get) === null || _9 === void 0 ? void 0 : _9.pricePreview) === null || _10 === void 0 ? void 0 : _10.showAOV) {
                elements.push(this.generator.twoColSetup(translation_1.default.t('Gesamtpreis über Laufzeit'), translation_1.default.transformCurrency((0, aov_helper_const_1._CalculateAOV_V2)(this.selectedTerm, this.paidModules, this.preview).total) + '€', {
                    fontSize: '12px',
                    fontWeight: 'bold',
                    color: 'rgba(26, 41, 54, .75)',
                }));
            }
            if (((_12 = (_11 = this.config.get) === null || _11 === void 0 ? void 0 : _11.pricePreview) === null || _12 === void 0 ? void 0 : _12.hideMembershipExtensionNotice) !== true) {
                var inlineAOVText = '';
                if ((_14 = (_13 = this.config.get) === null || _13 === void 0 ? void 0 : _13.pricePreview) === null || _14 === void 0 ? void 0 : _14.showAOVInSummaryText) {
                    inlineAOVText = "".concat(translation_1.default.t('Gesamtpreis über Laufzeit'), " ").concat(translation_1.default.transformCurrency((0, aov_helper_const_1._CalculateAOV_V2)(this.selectedTerm, this.paidModules, this.preview).total) + '€', ". ");
                }
                var subsequentTerm = (_17 = (_16 = (_15 = this.selectedTerm) === null || _15 === void 0 ? void 0 : _15.subsequentRateDto) === null || _16 === void 0 ? void 0 : _16.terms) === null || _17 === void 0 ? void 0 : _17[0];
                var subsequentPayment = paymentText;
                if (subsequentTerm) {
                    var paymentInterval_1 = subsequentTerm.paymentFrequencyValue + ' ' + subsequentTerm.paymentFrequencyUnit + 'S';
                    subsequentPayment =
                        this.timeMapping[paymentInterval_1] ||
                            translation_1.default.t('Every') +
                                ' ' +
                                subsequentTerm.paymentFrequencyValue +
                                ' ' +
                                translation_1.default.t(subsequentTerm.paymentFrequencyUnit + 'S');
                }
                var subsequentPrice = subsequentTerm ? subsequentTerm.price : price;
                var perInfoMessage = ((_19 = (_18 = this.selectedTerm) === null || _18 === void 0 ? void 0 : _18.priceAdjustmentRules) === null || _19 === void 0 ? void 0 : _19.length)
                    ? ''
                    : " ".concat(translation_1.default.t('zu je'), " ").concat(subsequentPayment, " ").concat(translation_1.default.transformCurrency(subsequentPrice), "\u20AC");
                console.log('subsequent term', subsequentTerm, 'payment', subsequentPayment, 'price', subsequentPrice, 'results in', perInfoMessage);
                elements.push(this.generator.getRow({
                    html: "".concat(inlineAOVText).concat(translation_1.default.t('Mindestlaufzeit'), " ").concat(contractDuration, " ").concat(translation_1.default.t(contractDuration > 1 ? this.selectedTerm.termUnit + 'S' : this.selectedTerm.termUnit), ". ").concat(translation_1.default.t('Wenn du nicht'), " ").concat(this.selectedTerm.cancellationPeriod, " ").concat(translation_1.default.t(this.selectedTerm.cancellationPeriod > 1
                        ? this.selectedTerm.cancellationPeriodUnit + 'S'
                        : this.selectedTerm.cancellationPeriodUnit), " ").concat(translation_1.default.t('vor Ablauf der Mindestlaufzeit kündigst, wird deine Mitgliedschaft automatisch'), " \n              ").concat(cancellationPeriodText, " ").concat(translation_1.default.t('kündbare Mitgliedschaft')).concat(perInfoMessage, " ").concat(translation_1.default.t('weitergeführt')),
                    css: { fontSize: '12px' },
                }));
            }
        }
        var priceAdjustments = '';
        //Price adjustments
        if ((_21 = (_20 = this.selectedTerm) === null || _20 === void 0 ? void 0 : _20.priceAdjustmentRules) === null || _21 === void 0 ? void 0 : _21.length) {
            for (var _25 = 0, _26 = this.selectedTerm.priceAdjustmentRules; _25 < _26.length; _25++) {
                var priceAdjustment = _26[_25];
                priceAdjustments += priceAdjustment.defaultDescription + '. ';
            }
            elements.push(this.generator.getRow({
                html: priceAdjustments,
                css: { fontSize: '12px' },
            }));
        }
        for (var _27 = 0, elements_1 = elements; _27 < elements_1.length; _27++) {
            var entry = elements_1[_27];
            this.$container.append(entry);
        }
    };
    RenderGivenPricePreview.prototype.addExtraModules = function (type, selectedModules) {
        var moduleElements = [];
        var modulesAdded = 0;
        var _loop_2 = function (moduleId) {
            var modules = type === 'free' ? this_2.selectedOffer.selectableModules : this_2.selectedTerm.optionalModules;
            var module_1 = modules.find(function (a) { return +a.id === +moduleId; });
            if (module_1) {
                modulesAdded++;
                var priceText = module_1.price === 0 ? translation_1.default.t('free') : translation_1.default.transformCurrency(module_1.price) + '€';
                if (module_1.paymentFrequencyType === 'RECURRING') {
                    priceText = this_2.i18nPrice(module_1.price, module_1.paymentFrequencyUnit, module_1.paymentFrequencyValue);
                }
                moduleElements.push(this_2.generator.twoColSetup(module_1.name, priceText, {
                    fontSize: '12px',
                }));
            }
        };
        var this_2 = this;
        for (var _i = 0, selectedModules_1 = selectedModules; _i < selectedModules_1.length; _i++) {
            var moduleId = selectedModules_1[_i];
            _loop_2(moduleId);
        }
        if (modulesAdded > 0) {
            moduleElements.unshift(this.generator.twoColSetup(type === 'free' ? 'Kostenlose Module' : 'Module', '', {
                fontSize: '12px',
                fontWeight: 'bold',
                color: 'rgba(26, 41, 54, .75)',
            }));
            moduleElements.unshift(this.generator.getDividerLine());
        }
        return moduleElements;
    };
    //True = bonustime and False = testzeitraum
    RenderGivenPricePreview.prototype.checkBonusTime = function (bonus) {
        return (bonus.termValue > 1 && bonus.termUnit === 'MONTH') || (bonus.termValue > 20 && bonus.termUnit === 'DAY');
    };
    RenderGivenPricePreview.prototype.testOrBonusTime = function (bonus) {
        return this.checkBonusTime(bonus) ? translation_1.default.t('bonusTime') : translation_1.default.t('freeTest');
    };
    RenderGivenPricePreview.prototype.roundDecimals = function (toRound, floatingPoints) {
        var factor = Math.pow(10, floatingPoints);
        return Math.round(toRound * factor) / factor;
    };
    RenderGivenPricePreview.prototype.formatDate = function (date) {
        var _a, _b, _c;
        var dateSplits = date.split('-');
        if (dateSplits.length !== 3) {
            return date;
        }
        return ((_a = dateSplits[2]) !== null && _a !== void 0 ? _a : '') + '.' + ((_b = dateSplits[1]) !== null && _b !== void 0 ? _b : '') + '.' + ((_c = dateSplits[0]) !== null && _c !== void 0 ? _c : '');
    };
    RenderGivenPricePreview.prototype.bonusPeriodInSummary = function (elements) {
        var _a, _b, _c, _d, _e;
        if (((_b = (_a = this.selectedTerm) === null || _a === void 0 ? void 0 : _a.rateBonusPeriods) === null || _b === void 0 ? void 0 : _b.length) && ((_d = (_c = this.config.get) === null || _c === void 0 ? void 0 : _c.pricePreview) === null || _d === void 0 ? void 0 : _d.dontShowFreeTestPeriod) !== true) {
            var bonus = (_e = this.selectedTerm) === null || _e === void 0 ? void 0 : _e.rateBonusPeriods[0];
            var textValue = bonus.termValue + ' ' + translation_1.default.t(bonus.termValue > 1 ? bonus.termUnit + 'S' : bonus.termUnit);
            var strategyText = translation_1.default.t('After');
            if (bonus.termStrategy === 'END_OF_CURRENT_TERM') {
                strategyText = translation_1.default.t('After contract period');
            }
            elements.push(this.generator.getRow({
                html: "".concat(strategyText, " ").concat(textValue, " ").concat(this.testOrBonusTime(bonus)),
                css: { fontSize: '12px' },
            }));
        }
    };
    RenderGivenPricePreview.prototype.bonusTimeElements = function (elements, bonus) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (((_b = (_a = this.config.get) === null || _a === void 0 ? void 0 : _a.pricePreview) === null || _b === void 0 ? void 0 : _b.dontShowFreeTestPeriod) === true)
            return;
        if (this.checkBonusTime(bonus)) {
            elements.push(this.generator.twoColSetup((_e = (_d = (_c = this.config.get) === null || _c === void 0 ? void 0 : _c.pricePreview) === null || _d === void 0 ? void 0 : _d.bonusRateString) !== null && _e !== void 0 ? _e : '14 Tage - kostenlos testen', (_h = (_g = (_f = this.config.get) === null || _f === void 0 ? void 0 : _f.pricePreview) === null || _g === void 0 ? void 0 : _g.bonusRatePrice) !== null && _h !== void 0 ? _h : '0€', {
                fontSize: '12px',
            }));
        }
        elements.push(this.generator.twoColSetup(bonus.termValue +
            ' ' +
            translation_1.default.t(bonus.termValue > 1 ? bonus.termUnit + 'S' : bonus.termUnit) +
            ' - ' +
            this.testOrBonusTime(bonus), '0€', { fontSize: '12px' }));
    };
    RenderGivenPricePreview.prototype.i18nPrice = function (price, interval, frequency) {
        if (price === 0) {
            return translation_1.default.t('free');
        }
        else {
            if (this.timeMapping[frequency + ' ' + interval]) {
                return this.timeMapping[frequency + ' ' + interval] + ' ' + translation_1.default.transformCurrency(price) + '€';
            }
            var newInterval = this.i18nInterval(interval, price);
            return translation_1.default.t('Every') + ' ' + frequency + ' ' + newInterval + ' ' + translation_1.default.transformCurrency(price) + '€';
        }
    };
    RenderGivenPricePreview.prototype.i18nInterval = function (interval, value) {
        return translation_1.default.t(value > 1 ? interval + 'S' : interval);
    };
    return RenderGivenPricePreview;
}());
exports.RenderGivenPricePreview = RenderGivenPricePreview;
